import React from "react";
import { Flex } from "src/elements/Box/Box";

interface Props {
  width: string;
  isDisabled?: boolean;
  children: React.ReactNode;
}

export const InputOuterContainer = ({ width, isDisabled, children }: Props) => (
  <Flex direction="column" gap="3px" width={width} userSelect={isDisabled ? "none" : "auto"}>
    {children}
  </Flex>
);
